import { extend } from "../../../../../node_modules/webdriver-js-extender";

export class CompartViewModel {
    public CompartId: number;
    public CompartName: string;
    public CompartType: string;
    public Model: string;
    public Make: string;
    public MakeId: number;
    public ContributionPercentage:number;
    public calculatedPercent:number;

    public ActiveObsCount:number;
    public InActiveObsCount:number;

}





export class CompartMeasurementPonitsViewModel {
    public Compart: CompartViewModel;
    public MeasurementPointsViewModels: MeasurementPointsViewModel[];
}

export class MeasurementPointsViewModel {
    public MeasurementPonitId: number;
    public CompartId: number;
    public Name: string;
    public Order: number;
    public DefaultNumberOfMeasurements: number;
    public DefaultToolId: number;
    public ToolName: string;

    public isDisabled: boolean;
    public CalculationMethods: CalculationMethod[];
    public BugetLife: number;
    public ContributionPercentage:number|null;
    public worn_0_prec:number|null;
    public worn_100_prec_Dim:number|null;
    public Tolerance:number|null;
    public WSREType:number|null;
    public StartingDim:number;
    public EndingDim:number;
    public CalcMethod :string;
    public isFrame:boolean
    public Models :number[];
    public ModelName:string;
    public WSRETypeName:string;
    public DealerGroupId:number;
    public DealerGroupName:string;
    public StandardCostRepair:number;
    public StandardHourRepair:number;
    public InspectionType: string;
    public ToleranceType: string;
}
export class WSREMeasurementPoints {
    public Id: number;
    public Name: string;
    public Type: number;
    public Order:number;
}

export class CreateMeasurementPointModel extends MeasurementPointsViewModel {
    public Image: string;
}


export class MeasurementToolsViewModel {
    public ToolId: number;
    public ToolCode: string;
    public ToolName: string;
}



export class MeasurementCalculationMethodCreationModel {
    public CompartId: number;
    public MakeId: number;
    public ToolId: number;
    public BugetLife: number;
    public WornCalculationMethodTableAutoId: number;
    public MeasurementPointId: number;
    public CalculationMethods: CalculationMethod[];
}

export class CalculationMethod {
    public CompartId: number;
    public ToolId: number;
    public MeasurementPointId: number;
    public CalculationMethodId: number;//todo
    public WornCalculationMethodTypeId: number;
    public BugetLife: number;
    public MakeId: number;
    public CompartEXTId: number;
}






export class SteppedCalMethodViewModel extends CalculationMethod {
    public StartDepthNew: number = 0;
    public StartDepth_10: number = 0;
    public StartDepth_20: number = 0;
    public StartDepth_30: number = 0;
    public StartDepth_40: number = 0;
    public StartDepth_50: number = 0;
    public StartDepth_60: number = 0;
    public StartDepth_70: number = 0;
    public StartDepth_80: number = 0;
    public StartDepth_90: number = 0;
    public StartDepth_100: number = 0;
    public StartDepth_110: number = 0;
    public StartDepth_120: number = 0;
    public StartingDim:number;
    public EndingDim:number;


}


export class InflectionCalMethodViewModel extends CalculationMethod {
    public Hi_InflectionPoint: number;
    public Hi_Slope1: number;
    public Hi_Intercept1: number;
    public Hi_Slope2: number;
    public Hi_Intercept2: number;
    public Mi_InflectionPoint: number;
    public Mi_Slope1: number;
    public Mi_Intercept1: number;
    public Mi_Slope2: number;
    public Mi_Intercept2: number;
    public Adjust_base: number;
    public Slope: number;
    public StartingDim:number;
    public EndingDim:number;
}

export class PolynomialCalMethodViewModel extends CalculationMethod {
    public Slope_Impact: number;
    public Slope_Normal: number;
    public Impact_Slope: number;
    public Normal_Slope: number;
    public Impact_Intercept: number;
    public Normal_Intercept: number;
    public Impact_Secondorder: number;
    public Normal_Secondorder: number;
    public StartingDim:number;
    public EndingDim:number;

}


export class LinearCalMethodViewModel extends CalculationMethod {
    public Impact_Slope: number;
    public Normal_Slope: number;
    public Impact_Intercept: number;
    public Normal_Intercept: number;
    public StartingDim:number;
    public EndingDim:number;

}


export class JDCalMehtodViewModel extends CalculationMethod {
    public Impact_Slope: number;
    public Normal_Slope: number;
    public Impact_Intercept: number;
    public Normal_Intercept: number;
    public StartingDim:number;
    public EndingDim:number;

}



export class UpdateAllCalculationMethods {
    SteppedMethods: SteppedCalMethodViewModel[] = [];
    InflectionMethods: InflectionCalMethodViewModel[] = [];
    PolyMethods: PolynomialCalMethodViewModel[] = [];
    JDMethods: JDCalMehtodViewModel[] = [];
    LinearMethods: LinearCalMethodViewModel[] = [];
}

export class CopyObsPointModel {
    ModelId: number;
    CompartId: number;
    DealerId: number;
    ObsPoints: CopyObsPoint[];  // Array of CopyObsPoint objects

   
}
export class CopyObsPoint {
    MeasurementPointId: number;
}





export enum CalculationMethodType {
    STEPPED = 1,//ITM
    Inflection = 2,//CAT
    Polynomial = 3,//Komatsu
    //Hitachi deleted =4
    Linear = 5,//liebherr
    JD = 6, //JD
    None = 7,//None
}
